import {
  FETCH_PROCESSING_SUMMARY_START,
  FETCH_PROCESSING_SUMMARY_SUCCESS,
  FETCH_PROCESSING_SUMMARY_ERROR,
  ADD_PROCESSING_SUMMARY_START,
  ADD_PROCESSING_SUMMARY_SUCCESS,
  ADD_PROCESSING_SUMMARY_ERROR,
  DELETE_PROCESSING_SUMMARY_START,
  DELETE_PROCESSING_SUMMARY_ERROR,
  DELETE_PROCESSING_SUMMARY_SUCCESS,
  UPDATE_PROCESSING_SUMMARY_START,
  UPDATE_PROCESSING_SUMMARY_ERROR,
  UPDATE_PROCESSING_SUMMARY_SUCCESS
} from '../../constants/ActionTypes';

const INIT_STATE = {
  data: [],
  currentPage: 1,
  pageSize: 10,
  totalItems: 0,
  loading: false,
  error: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_PROCESSING_SUMMARY_START:
    case DELETE_PROCESSING_SUMMARY_START:
    case UPDATE_PROCESSING_SUMMARY_START:
    case FETCH_PROCESSING_SUMMARY_START: {
      return {
        ...state,
        loading: true,
      };
    }

    case ADD_PROCESSING_SUMMARY_ERROR:
    case DELETE_PROCESSING_SUMMARY_ERROR:
    case UPDATE_PROCESSING_SUMMARY_ERROR:
    case FETCH_PROCESSING_SUMMARY_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FETCH_PROCESSING_SUMMARY_SUCCESS: {
      const { totalItems, currentPage, data } = action.payload;

      return {
        ...state,
        loading: false,
        data,
        totalItems,
        currentPage
      };
    }

    case ADD_PROCESSING_SUMMARY_SUCCESS: {
      const allITems = state.data;
      allITems.push(action.payload);
      return {
        ...state,
        loading: false,
        data: allITems,
      };
    }

    case DELETE_PROCESSING_SUMMARY_SUCCESS: {
      const updatedData = state.data.filter(
        (paymentMethod) => paymentMethod._id !== action.payload,
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    case UPDATE_PROCESSING_SUMMARY_SUCCESS: {
      const updatedData = state.data.map(
        (paymentMethod) => (
          paymentMethod._id !== action.payload._id ? paymentMethod : action.payload
        ),
      );
      return {
        ...state,
        loading: false,
        data: updatedData,
      };
    }

    default:
      return state;
  }
};
